import { useApp } from "components/AppContext";
import { ctxIsApp } from "lib/app";

export const withAppSwitch = ({ App, Web }) => {
  const Component = (props) => {
    const { isApp } = useApp();
    if (isApp && App) {
      return <App {...props} />;
    }
    if (!isApp && Web) {
      return <Web {...props} />;
    }
    return null;
  };

  Component.getInitialProps = (ctx) => {
    const isApp = ctxIsApp(ctx);
    if (isApp && App) {
      return App.getInitialProps?.(ctx);
    }
    if (!isApp && Web) {
      return Web.getInitialProps?.(ctx);
    }
  };

  return Component;
};
